






































































































import Vue from 'vue'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import {
  FETCH_SEARCH_PRODUCT_LIST,
  PROJECT_ASSISTANT_FETCH_UNIT_LIST,
  QUICK_INSERT_PROJECT_DETAILS
} from '@/store/action-types'
import { GetUnitCodeListResponse, ProductSearchResponse, QuickInsertResponse, UnitCode } from '@/types/service-response'
import ProductSearch from '@/components/project/ProductSearch.vue'
import { ProductSearchResult } from '@/model/project/ProductSearchResult'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'
import { ProductSearchRequest, QuickInsertPayload, QuickProjectDetailsPayload } from '@/types/payload'
import _ from 'lodash'
import NumberField from '@/components/NumberField.vue'

interface DataType {
  id: number
  produktId: number
  produktSortierung: string
  produktBezeichnung: string
  menge: number
  unit: number
  einheitCode: string
  meldungen: string
  lagerung: number
  produkt: ProductSearchResult
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  saveInProgress: boolean

  unitList: UnitCode[]
  gridData: DataType[]
  selectedRow: DataType | undefined

  valid: boolean
  isEdit: boolean
  isDisabledForm: boolean
  schluessel: string | null
  menge: number
  mengeEinheiten: number | null
  produkt: ProductSearchResult | null
  productList: ProductSearchResult[]
  decimalRules: Array<Function>
  rules: Array<Function>
  showSearchDialog: boolean
}

export default Vue.extend({
  name: 'CreateProjectDetailFastDialog',

  components: {
    ProgressCircular,
    ProductSearch,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    NumberField
  },

  props: {
    showDialog: Boolean,
    projectId: Number
  },

  data (): ComponentData {
    const decimalRule = (value: string) => {
      const pattern = /^(\d+(?:[\.\,]\d{1,5})?)$/
      return pattern.test(value) || ''
    }
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      saveInProgress: false,

      unitList: [],
      gridData: [],
      selectedRow: undefined,

      valid: false,
      isEdit: false,
      isDisabledForm: true,
      schluessel: null,
      menge: 0.000,
      mengeEinheiten: null,
      produkt: null,
      productList: [],
      decimalRules: [decimalRule],
      rules: [(value: any): boolean | string => !!value || ''],
      showSearchDialog: false
    }
  },

  watch: {},

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isCreateButtonDisabled (): boolean {
      return this.gridData.length === 0
    },
  },

  methods: {
    formatNumber(value: number | null, digital: number): any {
      if(value !== null) {
        return new Intl.NumberFormat(navigator && navigator.language ? navigator.language : "de-CH", {
          style: "decimal",
          minimumFractionDigits: digital,
          maximumFractionDigits: digital
        }).format(value)
      } else {
        return ''
      }
    },

    onRowClick (data: any): void {
      this.selectedRow = this.gridData[data.loadIndex]
    },

    onCancelClick (): void {
      this.isEdit = false
      this.unitList = []
      this.schluessel = null
      this.menge = 0.000
      this.mengeEinheiten = null
      this.produkt = null
      this.productList = []
      this.isDisabledForm = true
      //@ts-ignore
      this.$refs.form.resetValidation()
    },

    onSaveClick (): void {
      //@ts-ignore
      if(this.$refs.form.validate() && this.produkt && this.mengeEinheiten) {
        const unit: UnitCode | undefined = this.unitList.find((item: UnitCode) => item.ID === this.mengeEinheiten)

        if (this.isEdit) {
          if(this.selectedRow) {
            this.selectedRow.produktId = this.produkt.produkt
            this.selectedRow.produktSortierung = this.produkt.produktSortierung ? this.produkt.produktSortierung : ''
            this.selectedRow.produktBezeichnung = this.produkt.produktBezeichnung ? this.produkt.produktBezeichnung : ''
            this.selectedRow.menge = this.menge
            this.selectedRow.unit = this.mengeEinheiten
            this.selectedRow.einheitCode = unit && unit.Code ? unit.Code : ''
            this.selectedRow.lagerung = this.produkt.lagerung
            this.selectedRow.produkt = this.produkt
          }
          this.isEdit = false
        } else {
          const maxItem: DataType | undefined = _.maxBy(this.gridData, 'id')
          this.gridData.unshift({
            id: maxItem ? maxItem.id + 1 : 1,
            produktId: this.produkt.produkt,
            produktSortierung: this.produkt.produktSortierung ? this.produkt.produktSortierung : '',
            produktBezeichnung: this.produkt.produktBezeichnung ? this.produkt.produktBezeichnung : '',
            menge: this.menge,
            unit: this.mengeEinheiten,
            einheitCode: unit && unit.Code ? unit.Code : '',
            meldungen: '',
            lagerung: this.produkt.lagerung,
            produkt: this.produkt
          })
        }
        setTimeout(() => {
          const saveListButton: any = this.$refs['saveListButton']
          if (saveListButton) {
            saveListButton.$el.focus()
          }
        }, 0)
        this.onCancelClick()
      }
    },

    onAddClick (): void {
      this.isDisabledForm = false
      this.$nextTick(() => {
        //@ts-ignore
        this.$refs.product.focus()
      })
    },

    onEditClick (): void {
      if(this.selectedRow) {
        this.isEdit = true
        this.isDisabledForm = false
        this.schluessel = this.selectedRow.produktSortierung
        this.menge = this.selectedRow.menge
        this.mengeEinheiten = this.selectedRow.unit
        this.produkt = this.selectedRow.produkt
        this.fetchUnitList(this.selectedRow.produkt)
        this.$nextTick(() => {
          //@ts-ignore
          this.$refs.product.focus()
        })
      }
    },

    onDeleteClick (): void {
      if(this.selectedRow) {
        this.gridData = this.gridData.filter((item: DataType) => item.id !== this.selectedRow!.id)
        this.selectedRow = undefined
      }
    },

    async searchProduct (): Promise<void> {
      if(this.schluessel) {
        const payload: ProductSearchRequest = {
          Schluessel: this.schluessel,
          Bezeichnung: null,
          Lagercode: null,
          Gruppe: null,
          Barcode: null,
          KlProduktivNr: null,
          Verfuegbar: null,
          NurBevorzugteLager: null,
          NurAuslierfortSyzSRO: null,
          GesperrteAusblenden: null,
          VerfuegbarReservationen: null,
          VerfuegbarBestellungen: null,
          Sprache: this.selectedLanguageId,
          Mitarbeiter: this.currentUserId
        }

        try {
          this.loading = true
          const response: ProductSearchResponse = await this.$store.dispatch(FETCH_SEARCH_PRODUCT_LIST, payload)
          if (!response.IsError && response.Results) {
            this.productList = ProductSearchResult.createFromResponse(response.Results)
            if(this.productList.length === 1) {
              this.produkt = this.productList[0]
              this.schluessel = this.produkt.produktSortierung
              this.mengeEinheiten = this.produkt.einheit
              this.$nextTick(() => {
                //@ts-ignore
                this.$refs.menge.focus()
                //@ts-ignore
                this.$refs.menge.$el.querySelector('input').select()
              })
              this.fetchUnitList(this.produkt)
            } else {
              this.showSearchDialog = true
            }
          }
          this.loading = false
        } catch {
          this.loading = false
        }
      } else {
        this.showSearchDialog = true
      }
    },

    onSearchClick (): void {
      this.showSearchDialog = true
    },

    onSelectedProduct (data: ProductSearchResult): void {
      this.showSearchDialog = false
      this.isDisabledForm = false
      this.produkt = data
      this.schluessel = this.produkt.produktSortierung ? this.produkt.produktSortierung : ''
      this.mengeEinheiten = this.produkt.einheit
      this.$nextTick(() => {
        //@ts-ignore
        this.$refs.menge.focus()
        //@ts-ignore
        this.$refs.menge.$el.querySelector('input').select()
      })
      this.fetchUnitList(this.produkt)
    },

    onMengeChange (): void {
      if(this.menge == null) {
        this.menge = 0.000
      }
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
    },

    onCloseDialog (): void {
      if(!this.saveInProgress) {
        this.$emit('onCloseDialog')
      }
    },

    async onSaveDetailList (): Promise<void> {
      const quickProjectDetails: QuickProjectDetailsPayload[] = this.gridData.map((item: DataType) => {
        return {
          ProductId: item.produktId,
          Quantity: item.menge,
          Unit: item.unit,
          Lagerung: item.lagerung
        }
      })

      const payload: QuickInsertPayload = {
        ProjectId: this.projectId,
        EmployeeId: this.currentUserId,
        LanguageId: this.selectedLanguageId,
        QuickProjectDetails: quickProjectDetails.reverse()
      }
      try {
        this.saveInProgress = true
        const response: QuickInsertResponse = await this.$store.dispatch(QUICK_INSERT_PROJECT_DETAILS, payload)
        this.saveInProgress = false
        if(response && !response.IsError) {
          this.$emit('createdProjectDetailFast', response.LastProjectDetailId)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.saveInProgress = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchUnitList (product: ProductSearchResult | null): Promise<void> {
      const payload: any = {
        productId: product ? product.produkt : 0,
        projectId: this.projectId!,
        lagerung: product ? product.lagerung : 0
      }
      try {
        this.loading = true
        const response: GetUnitCodeListResponse = await this.$store.dispatch(PROJECT_ASSISTANT_FETCH_UNIT_LIST, payload)
        this.loading = false
        if(!response.IsError && response.Data) {
          this.unitList = response.Data
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted (): void {
    this.isDisabledForm = false
    setTimeout(() => {
      //@ts-ignore
      this.$refs.product.focus()
    }, 0)
  }
})
